<div
  class="page-title d-flex align-items-center justify-content-start flex-wrap me-lg-20 py-lg-0 me-3 h-100"
>
  <ul
    class="breadcrumb breadcrumb-line fw-semibold fs-7 my-0 d-flex align-items-center"
  >
    <li
      *ngFor="let item of breadcrumbItems; let i = index; let last = last"
      class="breadcrumb-item text-gray-700 d-flex align-items-center text-sm"
    >
      <ng-container *ngIf="i === 0">
        <i
          class="ki-filled ki-home fs-6 me-2 text-xl cursor-pointer nav-home-icon"
          (click)="navigateToDashboard()"
        ></i>
      </ng-container>
      <span
        (click)="
          !last &&
            item.label !== 'Configurations' &&
            item.label !== 'Settings' &&
            item.label !== 'Library' &&
            item.label !== 'My Work' &&
            !isParentLabel(item.label) &&
            onBreadcrumbClick(item)
        "
        [ngClass]="{
          'cursor-pointer':
            !last &&
            item.label !== 'Configurations' &&
            item.label !== 'Settings' &&
            item.label !== 'Library' &&
            item.label !== 'My Work' &&
            !isParentLabel(item.label),
          'hover:text-default-primary':
            !last &&
            item.label !== 'Configurations' &&
            item.label !== 'Settings' &&
            item.label !== 'Library' &&
            item.label !== 'My Work' &&
            !isParentLabel(item.label),
        }"
      >
        {{ item.label }}</span
      >
      <span *ngIf="!last" class="mx-2 text-gray-600">›</span>
    </li>
  </ul>
</div>
